// Educators (teacher) portal routes.
export const EDUCATORS_ROUTE_LOGIN = '/educators/login';
// Teacher signup. Linked from the login page and the landing CTAs only while
// the cluster's teacher registration switch is open; otherwise unlisted and
// shared directly with teachers. Never in navigation or the sitemap (CP-11551).
export const EDUCATORS_ROUTE_SIGNUP = '/educators/signup';
export const EDUCATORS_ROUTE_TERMS = '/educators/terms';
